// extracted by mini-css-extract-plugin
export var quillEditor = "_fy-1";
export var variable = "_fy-0";